// @flow

import type {ApplicationState} from '../../types'

import {createSelector} from 'reselect'
import {getPlaceList} from './getPlaceList'
import {getCityMap} from '../../map/selectors/getCityMap'
import {getDistrictMap} from '../../map/selectors/getDistrictMap'

export function getPlaceDetailList(appState: ApplicationState): PlaceDetail[]{
  return _getPlaceDetailList(appState) 
}

const _getPlaceDetailList = createSelector(
  [getPlaceList, getCityMap, getDistrictMap],
  (placeList: ServiceProvider[], cities: Map<City>, districts: Map<District>) => {
    return placeList.map(p => {
      let city = null
      let district = null
      if (p._links.city) {
        city = cities[p._links.city] 
      }
      if (p._links.district) {
        district = districts[p._links.district]
      }
      return {
        name: p.name,
        city,
        district,
        _links: {
          self: p._links.self,
        }
      }
    })
  }
)

getPlaceDetailList.internal = _getPlaceDetailList
